const cwsVideo = () => {
  const playBtn = document.querySelectorAll(".play-video");

  playBtn.forEach((play) => {
    play.addEventListener("click", (e) => {
      e.preventDefault();

      let video = play.closest("[data-video-box]").querySelector("iframe");
      if (video !== null) {
        const src = video.getAttribute("src");

        play.style.display = "none";

        if (src.indexOf("youtube") > -1) {
          video.setAttribute("src", src + "?autoplay=1");
        } else {
          video.setAttribute("src", src + "&autoplay=1");
        }
      } else {
        video = play.closest("[data-video-box]").querySelector("video");

        play.style.display = "none";

        video.play();

        video.addEventListener("ended", () => {
          play.style.display = "flex";
        });
      }
    });
  });
};

cwsVideo();
